export const sharedPT = {
	fiscalReportDateFilterHint:
		"Este filtro utiliza a data da transação, não a data da emissão da nota fiscal.",
	fiscalReportDateFilterRechargeHint:
		"Este filtro utiliza a data da recarga, não a data da emissão da nota fiscal.",
	yes: "Sim",
	no: "Não",
};
